import {vars} from "../../../vars.js";

export const headerFixed = ()=> {

        const header = vars.header;
        let scrollPos = 0;
        const func = () => {
            if(header){
                let windowTop = window.pageYOffset;
                let windowHeight = window.innerHeight / 3;
                let headerHeight = header.offsetHeight;

                if(header.classList.contains('fixed')){
                    if (window.matchMedia("(min-width:1024px)").matches) {
                        if (windowTop > headerHeight) {
                            const headerNav = header.querySelector('.header__nav')
                            const headerChangeWidth = headerNav.scrollWidth + 56
                            header.classList.add('header-change')
                            header.style = `--header-change-width:${headerChangeWidth}px`
                        } else {
                            header.classList.remove('header-change')
                        }
                    } else {
                        if (header.classList.contains('header-change')) {
                            header.classList.remove('header-change')
                        }
                    }
                    if(windowTop > scrollPos){
                        if(windowTop > headerHeight){
                            header.style.transition = 'transform .5s';
                            header.style.transform = 'translateY(-200px)';
                            header.classList.add('header-hide')
                            header.classList.remove('header-show')
                        } else {
                            header.style.transition = 'none';
                            header.style.transform = `translateY(-${windowTop}px)`;
                        }
                    } else {
                        header.style.transition = 'transform .5s';
                        header.style.transform = '';
                        header.classList.add('header-show')
                        header.classList.remove('header-hide')
                    }
                    scrollPos = windowTop;
                }

            }
        }

        func()

        window.addEventListener('scroll', () => {
            func();
        });

}